import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CAPABILITIES } from "@/data/content";

export default function Capabilities() {
  const scrollTo = () => {
    const el = document.querySelector("#contact");
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="capabilities" data-testid="capabilities-section" className="relative py-32 lg:py-44 px-6 lg:px-24 bg-ink2">
      <div className="max-w-[1600px] mx-auto">
        <div className="mb-20 lg:mb-28 max-w-4xl">
          <p className="font-mono text-[10px] tracking-[0.35em] text-goldw uppercase mb-6">Chapter 03 — Capabilities</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.05]" data-testid="capabilities-headline">
            Design &amp; Build <span className="italic text-goldw">Capabilities</span>
          </h2>
          <p className="mt-6 text-sm sm:text-base text-zinc2 leading-relaxed max-w-2xl">
            A look at the standard of spaces we design and construct. Imagery shown is a
            representative design visualization — authentic AMAA project photography is
            being curated and will replace these visuals.
          </p>
        </div>

        <div className="space-y-24 lg:space-y-36">
          {CAPABILITIES.map((c, i) => (
            <motion.article
              key={c.category}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8 }}
              data-testid={`capability-${i}`}
              className={`grid lg:grid-cols-12 gap-8 lg:gap-14 items-center ${i % 2 === 1 ? "" : ""}`}
            >
              <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="relative overflow-hidden aspect-[16/10] group">
                  <motion.img
                    initial={{ scale: 1.15 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                    src={c.image}
                    alt={c.alt}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 border border-white/5 pointer-events-none" />
                  <span className="absolute bottom-4 left-4 font-mono text-[9px] tracking-[0.25em] uppercase text-ivory/70 bg-ink/60 backdrop-blur-sm px-3 py-2">
                    Representative design visualization
                  </span>
                </div>
              </div>
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <span className="font-mono text-[10px] tracking-[0.3em] text-goldw uppercase">{c.category}</span>
                <h3 className="mt-4 font-serif font-light text-3xl sm:text-4xl text-ivory">{c.title}</h3>
                <p className="mt-4 text-sm sm:text-base text-zinc2 leading-relaxed max-w-md">{c.copy}</p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {c.services.map((s) => (
                    <li key={s} className="font-mono text-[9px] tracking-[0.18em] uppercase text-zinc2 border border-white/10 px-3 py-2">
                      {s}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`capability-quote-${i}`}
                  onClick={scrollTo}
                  className="mt-8 inline-flex items-center gap-2 border border-goldw/50 text-goldw font-mono text-[10px] tracking-[0.25em] uppercase px-6 py-3 hover:bg-goldw hover:text-ink transition-colors duration-300"
                >
                  Request a Consultation <ArrowUpRight size={14} />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
